import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import updateBarLogo from '@/static/imgs/updateBarLogo.png'

import styles from './index.module.less'
import { Space } from 'antd'
import { OneButton, OneSecondaryButton } from '@yy/one-ui'
import { DisabledWithFormErrorButton } from './DisabledWithFormError'
interface Iprops {
  cancelConfirm: () => void
  okConfirm: () => void
  whenErrorSubmitDisabled?: boolean
  submitBtnProps?: React.ComponentProps<typeof OneButton>
  updateText?: string
}
const TopUpdateBar: React.FC<Iprops> = (props) => {
  const { cancelConfirm, okConfirm, whenErrorSubmitDisabled = false, submitBtnProps, updateText } = props
  const { t } = useTranslation()

  const submitButton = useMemo(() => {
    if (!whenErrorSubmitDisabled) {
      return (
        <OneButton onClick={okConfirm} type="primary" {...submitBtnProps}>
          {updateText || t('common.Update')}
        </OneButton>
      )
    }

    return (
      <DisabledWithFormErrorButton type="primary" onClick={okConfirm} {...submitBtnProps}>
        {t('common.Update')}
      </DisabledWithFormErrorButton>
    )
  }, [okConfirm, submitBtnProps, t, updateText, whenErrorSubmitDisabled])

  return (
    <div className={styles.updateBar}>
      <div className="flex justify_sb align_c" style={{ height: '100%', padding: '0 40px 0 28px' }}>
        <img src={updateBarLogo} width={240} />
        <Space>
          <OneSecondaryButton onClick={cancelConfirm}>{t('common.cancelUpdate')}</OneSecondaryButton>
          {submitButton}
        </Space>
      </div>
    </div>
  )
}

TopUpdateBar.displayName = 'TopUpdateBar'
export default TopUpdateBar
